// extracted by mini-css-extract-plugin
export default {"detailsContainer":"Aa7yzBM7htJ0pd0fcIqQ","title":"Nsz1P3cVCN6Wm268DP4E","descriptions":"fWgB7ykLIUGBuXNoonxC","actions":"ZwgNLPTnPrxV65Wj2wKA","deleteConfirm":"xkcMjlK613Ff2MGbiAjm"};